/* ============================================
   LOFLLY Liquid Glass Navigation v3.0 — Palo Alto
   ============================================ */
(function () {
  'use strict';

  var SELECTORS = {
    header:   '.site-header',        // hover 类挂这里
    nav:      '.menu__items',        // 胶囊宿主（主菜单容器）
    menuItem: '.menu__item'          // 胶囊目标
  };

  var CLASSES = {
    hovered:     'loflly-nav--hovered',
    pillHost:    'loflly-nav__pill-host',
    pill:        'loflly-nav-pill',
    pillVisible: 'loflly-nav-pill--visible'
  };

  var DESKTOP_MQ = '(min-width: 768px)';
  var teardowns = [];

  function teardownAll() {
    for (var i = 0; i < teardowns.length; i++) {
      try { teardowns[i](); } catch (e) {}
    }
    teardowns = [];
  }

  /* 模块 1：hover 触发奶白玻璃 */
  function initDesktopNavHover() {
    var header = document.querySelector(SELECTORS.header);
    if (!header) return;

    function add()    { header.classList.add(CLASSES.hovered); }
    function remove() { header.classList.remove(CLASSES.hovered); }
    function onFocusOut(e) { if (!header.contains(e.relatedTarget)) remove(); }

    header.addEventListener('mouseenter', add);
    header.addEventListener('mouseleave', remove);
    header.addEventListener('focusin',    add);
    header.addEventListener('focusout',   onFocusOut);

    teardowns.push(function () {
      header.removeEventListener('mouseenter', add);
      header.removeEventListener('mouseleave', remove);
      header.removeEventListener('focusin',    add);
      header.removeEventListener('focusout',   onFocusOut);
      header.classList.remove(CLASSES.hovered);
    });
  }

  /* 模块 2：滑动胶囊 */
  function initDesktopPill() {
    var nav = document.querySelector(SELECTORS.nav);
    if (!nav) return;

    nav.classList.add(CLASSES.pillHost);

    var pill = nav.querySelector('.' + CLASSES.pill);
    if (!pill) {
      pill = document.createElement('div');
      pill.className = CLASSES.pill;
      pill.setAttribute('aria-hidden', 'true');
      nav.appendChild(pill);
    }

    var rafId = null;
    var lastTarget = null;

    function moveTo(target) {
      if (target === lastTarget) return;
      lastTarget = target;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        var navRect = nav.getBoundingClientRect();
        var rect    = target.getBoundingClientRect();
        var x = rect.left - navRect.left + 4;
        var y = rect.top  - navRect.top  + 8;
        var w = rect.width  - 8;
        var h = rect.height - 16;
        pill.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
        pill.style.width  = w + 'px';
        pill.style.height = h + 'px';
        pill.classList.add(CLASSES.pillVisible);
      });
    }

    function hide() {
      lastTarget = null;
      if (rafId) cancelAnimationFrame(rafId);
      pill.classList.remove(CLASSES.pillVisible);
    }

    function onMouseOver(e) {
      var item = e.target.closest(SELECTORS.menuItem);
      if (item && nav.contains(item)) moveTo(item);
    }
    function onFocusIn(e) {
      var item = e.target.closest(SELECTORS.menuItem);
      if (item && nav.contains(item)) moveTo(item);
    }
    function onFocusOut(e) {
      if (!nav.contains(e.relatedTarget)) hide();
    }

    nav.addEventListener('mouseover',  onMouseOver);
    nav.addEventListener('mouseleave', hide);
    nav.addEventListener('focusin',    onFocusIn);
    nav.addEventListener('focusout',   onFocusOut);

    teardowns.push(function () {
      nav.removeEventListener('mouseover',  onMouseOver);
      nav.removeEventListener('mouseleave', hide);
      nav.removeEventListener('focusin',    onFocusIn);
      nav.removeEventListener('focusout',   onFocusOut);
      if (rafId) cancelAnimationFrame(rafId);
      if (pill && pill.parentNode) pill.parentNode.removeChild(pill);
      nav.classList.remove(CLASSES.pillHost);
    });
  }

  function init() {
    teardownAll();
    if (window.matchMedia(DESKTOP_MQ).matches) {
      initDesktopNavHover();
      initDesktopPill();
    }
    bindBreakpointReinit();
  }

  var mqList = null;
  function bindBreakpointReinit() {
    if (mqList) return;
    mqList = window.matchMedia(DESKTOP_MQ);
    var handler = function () { init(); };
    if (mqList.addEventListener) mqList.addEventListener('change', handler);
    else if (mqList.addListener) mqList.addListener(handler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && (e.target.querySelector('.site-header') ||
        e.target.classList.contains('shopify-section-header'))) {
      init();
    }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && (e.target.querySelector('.site-header') ||
        e.target.classList.contains('shopify-section-header'))) {
      teardownAll();
    }
  });
})();